function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } Object.defineProperty(subClass, "prototype", { value: Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }), writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/. */

/**
 * Poll for signup/signin confirmation for `account`.
 *
 * Triggers a `confirmed` message whenever the user has
 * confirmed the session.
 *
 * Triggers an `error` message if there was an error.
 */
import AuthErrors from '../../lib/auth-errors';
import Backbone from 'backbone';
import { VERIFICATION_POLL_IN_MS } from '../../lib/constants';

let SessionVerificationPoll = /*#__PURE__*/function (_Backbone$Model) {
  _inherits(SessionVerificationPoll, _Backbone$Model);

  var _super = _createSuper(SessionVerificationPoll);

  function SessionVerificationPoll(data) {
    var _this;

    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, SessionVerificationPoll);

    _this = _super.call(this, options, data);

    if (!options.account) {
      throw new Error('options.account required');
    }

    _this._account = options.account;
    _this._pollIntervalInMS = options.pollIntervalInMS || VERIFICATION_POLL_IN_MS;
    _this._window = options.window;
    return _this;
  }

  _createClass(SessionVerificationPoll, [{
    key: "destroy",
    value: function destroy() {
      this.stop();

      _get(_getPrototypeOf(SessionVerificationPoll.prototype), "destroy", this).call(this);
    }
    /**
     * Start waiting for a signup confirmation
     */

  }, {
    key: "start",
    value: function start() {
      if (!this._isWaiting) {
        this._isWaiting = true;

        this._poll();
      }
    }
    /**
     * Stop waiting for a signup confirmation
     */

  }, {
    key: "stop",
    value: function stop() {
      if (this._pollTimeout) {
        this._window.clearTimeout(this._pollTimeout);

        this._pollTimeout = null;
      }

      this._isWaiting = false;
    }
  }, {
    key: "_poll",
    value: function _poll() {
      if (!this._isWaiting) {
        return;
      }

      this._account.sessionStatus().then(result => this._onStatusComplete(result), err => this._onStatusError(err));
    }
  }, {
    key: "_onStatusComplete",
    value: function _onStatusComplete(result) {
      if (!this._isWaiting) {
        // no longer care about the result, abort.
        return;
      }

      if (result.verified) {
        this.trigger('verified');
        this._pollTimeout = null;
        this.stop();
      } else {
        this._pollTimeout = this._window.setTimeout(() => this._poll(), this._pollIntervalInMS);
      }
    }
  }, {
    key: "_onStatusError",
    value: function _onStatusError(err) {
      // The user's email may have bounced because it's invalid. Check
      // if the account still exists, if it doesn't, it means the email
      // bounced. Show a message allowing the user to sign up again.
      //
      // This makes the huge assumption that a confirmation email
      // was sent.
      if (AuthErrors.is(err, 'INVALID_TOKEN') && this._account.has('uid')) {
        this._account.checkUidExists().then(accountExists => {
          if (!accountExists) {
            err = AuthErrors.toError('SIGNUP_EMAIL_BOUNCE');
          } // account exists, but sessionToken has been invalidated.


          this.trigger('error', err);
          this.stop();
        });
      } else {
        this.trigger('error', err);
        this.stop();
      }
    }
  }]);

  return SessionVerificationPoll;
}(Backbone.Model);

export { SessionVerificationPoll as default };